<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>
          <strong>Редактировать онбординг</strong>
        </CCardHeader>
        <CCardBody>
          <OnboardingTabLinks />
          <OnboardingForm v-if="onboarding" :onboarding="onboarding" @save="updateOnboarding" />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { CRow, CCol, CCard, CCardHeader, CCardBody } from '@coreui/vue';
import OnboardingForm from '@/components/onboarding/OnboardingForm';
import OnboardingTabLinks from '@/components/onboarding/OnboardingTabLinks';

export default {
  components: {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    OnboardingForm,
    OnboardingTabLinks,
  },
  data() {
    return {
      onboarding: null,
    };
  },
  created() {
    this.fetchOnboarding();
  },
  methods: {
    async fetchOnboarding() {
      try {
        const response = await this.axios.get(`/onboarding/${this.$route.params.id}`);
        this.onboarding = response.data;        
      } catch (error) {
        this.$root.$emit('showError', 'Ошибка загрузки онбординга.');
      }
    },
    async updateOnboarding(onboarding) {
      try {
        await this.axios.put(`/onboarding/${this.$route.params.id}`, onboarding);
        
        this.$router.push('/onboarding');
      } catch (error) {
        this.$root.$emit('showError', error?.response?.data?.message || 'Ошибка обновления онбординга.');
      }
    },
  },
};
</script>
